module.exports = __webpack_public_path__ + "static/media/anatomia.b8f97c1b.png";